<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="container mx-auto px-0">
        <div class="grid md:grid-cols-2 items-stretch">
          <!-- Left Side: Timeline Content -->
          <div class="bg-white p-12 flex flex-col justify-center">
            <h2
              class="text-4xl mb-7"
            >{{ t("Zorgblik Academie – De leeromgeving voor de zorgprofessional van de toekomst!?") }}</h2>

            <p
              class="text-lg"
            >{{ $t('Werken en ontwikkelen zijn onlosmakelijk verbonden. Bij Zorgblik Academie bouwen we samen aan de toekomst van de zorg.') }}</p>
          </div>

          <!-- Right Side: Background Image -->
          <div class="w-full h-full">
            <img
              src="@/../img/home/hospital.jpg"
              alt="Achtergrond illustratie"
              class="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>